import ReactDOM from 'react-dom/client';
import './index.module.scss';
import './styles/themeColors.scss';
import Root from './components/Root';
import { store } from "./config/store";
import { datadogRum } from '@datadog/browser-rum';

const dev = process.env.NODE_ENV === 'development';
if(!dev){
    datadogRum.init({
        applicationId: '74a6cf43-6247-46bc-8668-4a4ee76f799d',
        clientToken: 'pub5de98d1fc6f8e513aa41c2d37f557a95',
        // `site` refers to the Datadog site parameter of your organization
        // see https://docs.datadoghq.com/getting_started/site/
        site: 'datadoghq.com',
        service: 'linze-360',
        env: process.env.NODE_ENV,
        // Specify a version number to identify the deployed version of your application in Datadog
        // version: '1.0.0',
        sessionSampleRate: 100,
        sessionReplaySampleRate: 20,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        defaultPrivacyLevel: 'mask-user-input',
    });
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

if(window?.Cypress){
    window.store = store;
}

root.render(<Root/>);